module.exports = __webpack_public_path__ + "img/banner.3e333db5.png";